const CHARS = {
  UPPERCASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  LOWERCASE: 'abcdefghijklmnopqrstuvwxyz',
  NUMBERS: '0123456789',
  SPECIAL: '!@#$%^&*(),.?":{}|<>',
};

export const generateSecurePassword = (length = 20): string => {
  const allChars =
    CHARS.UPPERCASE + CHARS.LOWERCASE + CHARS.NUMBERS + CHARS.SPECIAL;
  let password = '';

  // Garantir au moins un caractère de chaque type
  password += CHARS.UPPERCASE.charAt(
    Math.floor(Math.random() * CHARS.UPPERCASE.length)
  );
  password += CHARS.LOWERCASE.charAt(
    Math.floor(Math.random() * CHARS.LOWERCASE.length)
  );
  password += CHARS.NUMBERS.charAt(
    Math.floor(Math.random() * CHARS.NUMBERS.length)
  );
  password += CHARS.SPECIAL.charAt(
    Math.floor(Math.random() * CHARS.SPECIAL.length)
  );

  // Remplir le reste avec des caractères aléatoires
  for (let i = password.length; i < length; i++) {
    password += allChars.charAt(Math.floor(Math.random() * allChars.length));
  }

  // Mélanger le mot de passe
  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
};
